import {
  CategoryClassificationStatuses,
  IdNameModel,
  LookupDataState,
} from '@abb-procure/data';
import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  TemplateRef,
  booleanAttribute,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import {
  Classifiable,
  ClassificationPipe,
} from '../../pipes/classification.pipe';
import { Button } from '../button/button.component';

@Component({
  selector: 'procure-classification-grid',
  templateUrl: './classification-grid.component.html',
  styleUrl: './classification-grid.component.scss',
  imports: [ClassificationPipe, NgTemplateOutlet, Button, MatTooltip],
})
export class ClassificationGrid {
  readonly remove = output<string>();
  readonly add = output<IdNameModel>();

  readonly items = input.required<Classifiable[] | null>();

  readonly showMode = input.required<boolean, boolean | string>({
    transform: booleanAttribute,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly itemTemplate = input.required<TemplateRef<any>>();

  protected readonly statuses = computed(() =>
    this.lookupDataState.categoryClassificationStatuses(),
  );

  private readonly lookupDataState = inject(LookupDataState);

  protected onAdd(status: CategoryClassificationStatuses): void {
    this.add.emit(new IdNameModel({ id: status.id, name: status.name }));
  }
}
